import React from "react";
import { Badge, Button, Icon, Popover } from "antd";

import { Layout } from "~/components/UI";
import { ModuleHeader } from '~/components/ModuleHeader';
import FilterPillsBar from '~/_shared/components/FilterPillsBar';
import ListLinks from '~/containers/Plugins/components/clicks-count/ClicksCountModal/components/ListLinks';
import ReportsByGroup from '~/containers/Plugins/components/clicks-count/ClicksCountModal/components/ReportsByGroup';

var VIEWS = [
  { value: 'links', label: 'Links', color: '#1890ff', icon: 'link' },
  { value: 'report', label: 'Relatório', color: '#722ed1', icon: 'bar-chart' },
];

var PluginsClickCounter = function() {
  var addRef = React.useRef(null);
  var viewState = React.useState('links');
  var activeView = viewState[0];
  var setActiveView = viewState[1];

  var activeViewMeta = VIEWS.find(function(v) { return v.value === activeView; }) || VIEWS[0];

  return React.createElement(Layout, null,
    React.createElement('div', null,
      React.createElement(ModuleHeader, {
        breadcrumbs: ['Plugins', 'Contador de Cliques'],
        title: 'Contador de Cliques',
        center: React.createElement(React.Fragment, null,
          React.createElement(Popover, {
            trigger: 'click',
            placement: 'bottomRight',
            content: React.createElement('div', { style: { width: 280 } },
              React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 } },
                React.createElement('span', { style: { fontSize: 15, fontWeight: 600, color: '#262626' } }, 'Filtros')
              ),
              React.createElement('div', null,
                React.createElement('div', { style: { fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' } }, 'Visualizacao'),
                React.createElement('div', { style: { display: 'flex', flexDirection: 'column', gap: 6 } },
                  VIEWS.map(function(opt) {
                    var isActive = activeView === opt.value;
                    return React.createElement('div', {
                      key: opt.value,
                      onClick: function() { setActiveView(opt.value); },
                      style: {
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        padding: '6px 10px', borderRadius: 6, cursor: 'pointer',
                        border: '1.5px solid ' + (isActive ? opt.color : '#e8e8e8'),
                        background: isActive ? opt.color + '0a' : '#fafafa',
                        transition: 'all 0.2s',
                      }
                    },
                      React.createElement('span', { style: { fontSize: 12, color: isActive ? '#262626' : '#8c8c8c' } },
                        React.createElement(Icon, { type: opt.icon, style: { marginRight: 4 } }),
                        opt.label
                      ),
                      isActive && React.createElement(Icon, { type: 'check', style: { color: opt.color, fontSize: 12 } })
                    );
                  })
                )
              )
            )
          },
            React.createElement(Badge, {
              count: 1,
              offset: [-4, 0],
              style: { backgroundColor: '#722ed1' }
            },
              React.createElement(Button, { icon: 'bars', style: { borderRadius: 8 } }, 'Filtros')
            )
          ),
          activeView === 'links' && React.createElement(Button, {
            icon: 'plus',
            shape: 'circle',
            onClick: function() { if (addRef.current) addRef.current(); }
          })
        ),
        advanced: React.createElement(FilterPillsBar, {
          pills: [
            { key: 'view', label: activeViewMeta.label, color: activeViewMeta.color, icon: activeViewMeta.icon }
          ]
        })
      }),
      activeView === 'links'
        ? React.createElement(ListLinks, { isVisible: true, onAddRef: addRef })
        : React.createElement(ReportsByGroup, null)
    )
  );
};

export default PluginsClickCounter;
